
<!-- Настройка метода расчета -->

<template>

	<div class="h-100">

		<b-overlay :show="wait" v-if="group" class="pt-2 h-100">

			<setups ref="setups" v-on:need_refresh="refresh" :group_id="group_id" :group="group"/>

		</b-overlay>

	</div>

</template>

<script>

import api from "../../../api"
import setups from "./setups"

export default
{
	components :
	{
		setups,
	},

	data()
	{
		return {

			service : "cadastral_groups",
			group_id : null,
			group : {},

			wait : false,
			progress : false,
    
		}
	},

	created() 
	{
		this.group_id = this.$route.params.id

		this.refresh()
	},

	methods :
	{
		refresh(with_wait = true)
		{
			if(with_wait)
				this.wait = true

			return api.call(this, this.service, "get", { id : this.group_id },
					response =>
					{
						this.group = response.data
						this.wait = false

						this.group.not_editable = this.$root.not_editable //TODO
					})
		},

		set_cost()
		{
			this.$refs.set_cost.execute()
		},
		
		delete_this()
		{
			this.$bvModal.msgBoxConfirm(
				"При удалении расчета все данные будут удалены - в том числе КС у объектов оценки, если таковая рассчитывалась. Удалить расчет?",
				{
					title : "Подтверждение удаления",
					okVariant : "danger",
					okTitle : "Да",
					cancelVariant : "outline-primary-secondary",
					cancelTitle : "Нет",
					hideHeaderClose : false,
					centered : true
				})
				.then(
					value =>
					{
						if(value)
							api.call(this, this.service, "delete_cost_evaluation", { id : this.group_id }, () => this.go_back())
					})
		},

		go_back()
		{
			api.back.go(this)
		},
	}
}

</script>

<style>

.setups > .tab-content
{
	overflow-y: auto;
}

</style>

